import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { Text, Button } from '@humanspace/components';
import { Spacing } from '@humanspace/foundations';

const Container = styled.section`
  margin-bottom: ${Spacing.l};
`;

const Title = styled(Text)`
  margin-bottom: ${Spacing.s};
`;

const ButtonRow = styled.div`
  display: flex;
  gap: ${Spacing.m};
  margin-top: ${Spacing.l};
  ${props => props.isResponsive && `flex-direction: column;`}
`;

const StyledButton = styled(Button)`
  margin-left: 0;
`;

const ModelDetailsSection = ({ id, isResponsive, ...props }) => {
  const history = useHistory();

  return (
    <Container {...props}>
      <Title size="xl" bold lineHeight={1.2}>
        Do you want to know more?
      </Title>
      <Text size="m">
        Explore detailed model calculations or see how your results compare to
        industry benchmarks.
      </Text>
      <ButtonRow isResponsive={isResponsive}>
        <StyledButton
          full={isResponsive}
          secondary
          onClick={() => history.push(`/projects/${id}/model-details`)}>
          Model Details
        </StyledButton>
        <StyledButton
          full={isResponsive}
          secondary
          onClick={() => history.push(`/projects/${id}/benchmark`)}>
          Industry Benchmarks
        </StyledButton>
      </ButtonRow>
    </Container>
  );
};

export default ModelDetailsSection;
